export const createDefaultContent = (
  integrationId: string | null = null,
) => {
  return {
    key: '',
    integration_id: integrationId,
  }
};
